'use client';

import { useEffect } from 'react';

import { useRecentSearchesStorage } from '@/storage/recents-searches.storage';
import { initializeRecentSearches } from '@/store/search/search.store';

export default function LoadRecentSearchesComponent(): React.ReactNode {
  const [recentSearches] = useRecentSearchesStorage();

  useEffect(() => {
    if (recentSearches.length > 0) {
      initializeRecentSearches(recentSearches);
    }
  }, [recentSearches]);

  return null;
}
